import './App.css';
import Login from './components/login/Login';

function App() {
  return (

    <Login />

  );
}

export default App;
